export default "__VITE_ASSET__ysTS4ZKL__"